import { SocialIcon } from 'react-social-icons'

import s from './SocialLinks.module.sass'

export default function SocialLinks({ socialLinks }: { socialLinks: any }) {
    if (!socialLinks || !socialLinks?.length) {
        return null
    }

    return (
        <div className={s.SocialLinks}>
            <ul>
                {socialLinks.map((socialLink: any) => {
                    const { _key, link } = socialLink

                    return (
                        <li key={_key}>
                            <SocialIcon
                                url={link}
                                target="_blank"
                                bgColor="#FFF"
                                fgColor="#1522B0"
                                borderRadius="0%"
                                style={{ height: 36, width: 36 }}
                            />
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}
